import { Button, commitProtectedDocumentNavigation, requestProtectedAction, useEditProtection, useEditProtectionState } from "@ilabel/ui";
import { ApiError } from "@ilabel/platform-core";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./app-recovery.css";

export class AppInitializationError extends Error {}

export function AppInitializationFailure({ error, pending, retry }: { error: unknown; pending: boolean; retry: () => void }) {
  const title = error instanceof AppInitializationError ? "初始化信息未就绪"
    : error instanceof ApiError && error.code === "REQUEST_TIMEOUT" ? "初始化信息读取超时" : "初始化信息读取失败";
  return <div className="app-route-state app-recovery-state" role="alert">
    <strong>{title}</strong>
    <span>请重新读取；若问题持续，请联系管理员。</span>
    <Button variant="secondary" disabled={pending} loading={pending} onClick={retry}>重新读取</Button>
  </div>;
}

export function AppRouteUnavailable() {
  const navigate = useNavigate();
  return <div className="app-route-state app-recovery-state" role="alert">
    <strong>页面不可用</strong>
    <span>当前地址不存在，请返回有权访问的首页。</span>
    <Button variant="secondary" onClick={() => navigate("/", { replace: true })}>返回可用首页</Button>
  </div>;
}

export function AppRouteError({ resetErrorBoundary = () => window.location.reload() }: { resetErrorBoundary?: () => void }) {
  // Capture before React disposes the failed editor's registrations. The crashed
  // save cannot report completion here, so busy becomes an uncertain outcome.
  const beforeCrash = useRef(useEditProtectionState()).current;
  const outcomeUnknown = beforeCrash.busy || beforeCrash.outcomeUnknown;
  useEditProtection({ label: "页面恢复", dirty: beforeCrash.dirty, outcomeUnknown });
  return (
    <div className="app-route-state app-route-error app-recovery-state" role="alert">
      <strong>页面加载失败</strong>
      <span>请重试或返回可用首页。未保存的内容可能无法恢复。</span>
      {outcomeUnknown && <span>保存结果尚未确认，请先核对原操作；重新加载或离开不会撤回可能已保存的内容。</span>}
      <Button variant="secondary" onClick={() => void requestProtectedAction(resetErrorBoundary)}>重新加载</Button>
      <Button variant="secondary" onClick={() => void requestProtectedAction(() => commitProtectedDocumentNavigation("/", () => window.location.assign("/")), { navigationTarget: "/" })}>返回可用首页</Button>
    </div>
  );
}
